module.exports = __webpack_public_path__ + "img/logo1.134e2f8.png";